"use strict";

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton.classList.contains('gr-product-submit') && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
      // if (document.querySelector('.sticky-product-button')) {
      //   document.querySelector('.sticky-product-button').setAttribute('aria-disabled', true);
      //   document.querySelector('.sticky-product-button').classList.add('loading');
      //   document.querySelector('.sticky-product-button .loading__spinner').classList.remove('hidden');
      // }
      // document.querySelector('cart-drawer').classList.add('cart-loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (!formData.has('selling_plan')) {
        let sellingPlanId = '4620124389'; // Default selling plan ID
        let purchaseMode = 'subscription';
        try {
          purchaseMode = sessionStorage.getItem('grPurchaseMode') || 'subscription';
        } catch (e) {
          /* noop */
        }
        if (purchaseMode === 'one-time') {
          sellingPlanId = '';
        } else if (window.cart && window.cart.items && window.cart.items.length > 0) {
          const lastItem = window.cart.items[window.cart.items.length - 1];
          if (lastItem.selling_plan_allocation) {
            sellingPlanId = lastItem.selling_plan_allocation.selling_plan.id;
          }
        }
        formData.append('selling_plan', sellingPlanId);
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config).then(response => response.json()).then(response => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          if (document.querySelector('.sticky-product-button')) {
            document.querySelector('.sticky-product-button').setAttribute('aria-disabled', true);
            document.querySelector('.sticky-product-button').querySelector('span').classList.add('hidden');
          }
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response
        });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          }, {
            once: true
          });
          quickAddModal.hide(true);
        } else {
          if (this.submitButton.classList.contains('product-atc_button') && window.addType == 'checkout') {
            window.location.href = '/checkout';
          } else {
            var final_item = window.cart.items.filter(function (item) {
              return item.selling_plan_allocation;
            });
            var cItem = window.cart.items.filter(function (item) {
              return item.product_id == response.product_id;
            });
            var matchSell = false;
            if (cItem.length > 0) {
              if (cItem[0].selling_plan_allocation) {
                if (cItem[0].selling_plan_allocation.selling_plan.name == $('.selling-option option:selected').attr('data-name')) {
                  matchSell = true;
                }
              }
            }
            if (this.submitButton.classList.contains('product-atc_button') && $('.selling-option').attr('disabled') != 'disabled' && final_item.length > 0 && matchSell == false) {
              this.cart.renderContents(response, 'Yes');
              $.getJSON('/cart.js', function (cart) {
                window.cart = cart;
                window.cart['sections'] = response['sections'];
                addRemoveItem('subscription', $('.selling-option option:selected').attr('data-name'), false);
              });
            } else {
              this.cart.renderContents(response, 'Yes');
            }
          }
        }
      }).catch(e => {
        console.error(e);
      }).finally(() => {
        this.submitButton.classList.remove('loading');
        const productForms = document.querySelectorAll('.gr-card-product-new__product-form');
        if (productForms.length > 0) {
          productForms.forEach(form => {
            if (form.contains(this.submitButton)) {
              const cardProductElements = document.querySelectorAll('[data-card-variant-id]');
              if (cardProductElements.length > 0) {
                cardProductElements.forEach(cardProductElement => {
                  const cardProductId = cardProductElement.getAttribute('data-card-variant-id');
                  const quantityElement = document.querySelector(`[data-quantity-variant-id="${cardProductId}"]`);
                  if (quantityElement) {
                    const quantityValue = quantityElement.value;
                    cardProductElement.value = quantityValue;
                  }
                });
              }
              const parentCard = form.closest('.gr-products-grid__card');
              if (parentCard) {
                parentCard.classList.add('gr-products-grid__card--in-cart');
              }
            }
          });
        }
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
    }
    handleErrorMessage() {
      let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
function updateLocalCartState(variantId, quantity) {
  const cartItemElement = document.querySelector(`[data-quantity-variant-id="${variantId}"]`);
  if (cartItemElement) {
    cartItemElement.value = quantity;
  }
}
function updateServerCart(variantId, quantity) {
  const updateData = {
    updates: {},
    sections: 'cart-drawer,cart-icon-bubble'
  };
  updateData.updates[variantId] = quantity;
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(updateData)
  }).then(response => response.json()).catch(error => {
    console.error('Error updating cart:', error);
  });
}
let grCartUpdateSeq = 0;
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', event => {
    const cardProductElement = event.target.closest('[data-card-variant-id]');
    if (cardProductElement) {
      const cardProductId = cardProductElement.getAttribute('data-card-variant-id');
      const newQuantity = event.target.value;
      const quantityElement = document.querySelector(`[data-quantity-variant-id="${cardProductId}"]`);
      cardProductElement.setAttribute('data-gr-card-quantity', newQuantity);
      if (quantityElement) {
        quantityElement.value = newQuantity;
        quantityElement.setAttribute('data-gr-card-quantity', newQuantity);
      }
      const parentCard = cardProductElement.closest('.gr-products-grid__card');
      if (parentCard) {
        if (newQuantity === '0') {
          parentCard.classList.remove('gr-products-grid__card--in-cart');
        } else {
          parentCard.classList.add('gr-products-grid__card--in-cart');
        }
      }
      // Optimistic quantity engine (gr-purchase-mode.js): renders the UI
      // instantly and coalesces rapid clicks into a single /cart/update.js
      // request — no dropped inputs, no parallel-request races.
      if (window.grQueueCartUpdate) {
        window.grQueueCartUpdate(cardProductId, newQuantity);
        return;
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        // cartDrawer.classList.add('cart-loading');
      }
      // Fallback path. Sequence guard: rapid +/- clicks fire overlapping
      // requests; only the newest response is allowed to touch the DOM.
      const requestSeq = ++grCartUpdateSeq;
      updateServerCart(cardProductId, newQuantity).then(cartData => {
        if (requestSeq !== grCartUpdateSeq) return;
        let cartDrawerHTML = '';
        let cartOpenerHTML = '';
        let cartIconBubbleHTML = '';
        const domParser = new DOMParser();
        if (cartData?.sections?.['cart-drawer']) {
          const drawerDoc = domParser.parseFromString(cartData.sections['cart-drawer'], 'text/html');
          const drawerSection = drawerDoc.querySelector('.shopify-section cart-drawer');
          const drawerOpener = drawerDoc.querySelector('.shopify-section #CartMobOpener');
          cartDrawerHTML = drawerSection?.innerHTML;
          cartOpenerHTML = drawerOpener?.innerHTML;
          const pageCartDrawer = document.querySelector('cart-drawer');
          const pageCartOpener = document.querySelector('#CartMobOpener');
          pageCartDrawer.innerHTML = cartDrawerHTML;
          pageCartOpener.innerHTML = cartOpenerHTML;
        }
        if (cartData?.sections?.['cart-icon-bubble']) {
          const bubbleDoc = domParser.parseFromString(cartData.sections['cart-icon-bubble'], 'text/html');
          const bubbleSection = bubbleDoc.querySelector('.shopify-section');
          cartIconBubbleHTML = bubbleSection?.innerHTML;
          const pageCartBubble = document.querySelector('#cart-icon-bubble');
          pageCartBubble.innerHTML = cartIconBubbleHTML;
        }
        // Reconcile cart-dependent UI. The mutation payload is NOT passed:
        // its prices can be in a different market context than the session —
        // grRefreshCartState refetches /cart.js, the single price authority.
        if (window.grRefreshCartState) {
          window.grRefreshCartState();
        } else {
          updateLocalCartState(cardProductId, newQuantity);
        }
      }).finally(() => {
        if (cartDrawer) {
          cartDrawer.classList.remove('cart-loading');
        }
      });
    }
  });
  document.querySelectorAll('.gr-quantity__button--plus-clone').forEach(cloneButton => {
    cloneButton.addEventListener('click', () => {
      const parentCard = cloneButton.closest('.gr-card-product-new');
      if (parentCard) {
        const plusButton = parentCard.querySelector('.gr-quantity__button--plus');
        if (plusButton) {
          plusButton.click();
        }
      }
    });
  });
});